module.exports = __webpack_public_path__ + "img/scissor_lift.png";